exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination {\n  display: flex;\n  justify-content: center;\n  padding: 0.2rem 0;\n  background-color: #fff;\n}", ""]);

// exports
